import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly API_SCOPE = `api://${environment.backendClientId}/user_impersonation`;

  constructor(private msalService: MsalService) {}

  async getValidToken(): Promise<string> {
    const account = this.msalService.instance.getActiveAccount()
      ?? this.msalService.instance.getAllAccounts()[0];

    if (!account) {
      throw new Error('No active account. Please sign in.');
    }

    const result = await this.msalService.instance.acquireTokenSilent({
      account,
      scopes: [this.API_SCOPE],
    });
    return result.accessToken;
  }

  isLoggedIn(): boolean {
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  login(): void {
    this.msalService.loginRedirect({ scopes: [this.API_SCOPE] });
  }

  logout(): void {
    this.msalService.logoutRedirect();
  }

  getAccount() {
    return (
      this.msalService.instance.getActiveAccount() ??
      this.msalService.instance.getAllAccounts()[0] ??
      null
    );
  }
}
